<template>
    <div class="popup-box">
        <div class="popup-tit">{{ title }}</div>
        <div class="popup-list">
            <div class="popup-list-item flex-between flex-y-center" v-for="item, index in list" :key="index"
                @click="onChange(item)">
                <img v-if="item.avatar" class="head-img" :src="item.avatar" alt="">
                <div class="flex-1">
                    {{ item.name }}
                </div>
                <van-radio-group :value="checkedItem && checkedItem.id">
                    <van-radio :name="item.id" checked-color="#2FD0D5"></van-radio>
                </van-radio-group>
            </div>

        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { Field, Picker, Popup } from 'vant';
Vue.use(Field).use(Picker).use(Popup);

export default {
    name: "DatePicker",
    props: {
        title: {
            type: String,
            default: '',
            required: true
        },
        list: {
            type: Array,
            default: () => [],
            required: true
        },
        value: {
            type: Object | null,
            default: null,
            required: false
        },
    },
    data() {
        return {
            checkedItem: null
        };
    },

    computed: {

    },
    watch: {
        value: {
            handler(value) {
                this.checkedItem = value  
            },
            immediate: true
        }
    },
    mounted() {
    },
    methods: {
        onChange(item) {
            this.$emit('change', item)
        }
    },
}
</script>

<style scoped lang="less">
.popup-box {
    padding: 30px;
    height: 676px;
    overflow: hidden;
    .popup-tit {
        width: 100%;
        height: 48px;
        font-size: 34px;
        font-weight: 700;
        color: #35434c;
        margin-bottom: 50px;
    }

    .popup-list {
        overflow-y: auto;
        height: 100%;
        padding-bottom: 60px;

        .popup-list-item {
            width: 100%;
            height: 84px;
            font-size: 30px;
            font-weight: 400;
            color: #35434c;
            padding-bottom: 34px;
            border-bottom: 1px solid #d7d7d7;
            margin-bottom: 34px;

            .head-img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 20px;
            }
        }
    }
}

:deep(.van-radio) {
    margin-bottom: 0 !important;
}
</style>

